/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ICwsBuyNowViewProps } from './cws-buy-now';

export default (props: ICwsBuyNowViewProps) => {
    return <div className='cws-buy-now'>{props.buyNowButton}</div>;
};
